import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  span {
    visibility: hidden;
  }
  &:hover {
    span {
      visibility: visible;
    }
  }
`;

export default Wrapper(template)
